/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createTheme} from "@mui/material/styles";
import { theme } from "../../../constants/theme";

const themesMap: any = {
  sensorDescription: createTheme({
    components: {
      MuiCollapse: {
        styleOverrides: {
          wrapperInner: {
            display: "flex",
            justifyContent: "center",
            padding: "20px 0px 20px 0px", 
            width: "100%",
            overflow: "auto",
          },
        },
      },
    },
  })
};

export {themesMap}